export default "__VITE_ASSET__CwxNvHlx__"